// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: #fff !important;
    margin: 0;
    color: rgba(0, 0, 0, 0.87);
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5;
    letter-spacing: 0.00938em;
}



body,
.aishoppingresultdata {
    overflow-y: scroll !important;
    /* font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important; */

}

body::-webkit-scrollbar,
.aishoppingresultdata::-webkit-scrollbar {
    width: 3px !important;
}

body::-webkit-scrollbar-track,
.aishoppingresultdata::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 18px rgba(250, 250, 251, 0.3);
    border-radius: 2px;
    margin-top: 16px;
    margin-bottom: 16px;
}

body::-webkit-scrollbar-thumb,
.aishoppingresultdata::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: #25C9D0 !important;
    width: 6px !important;
}

body::-webkit-scrollbar-thumb:hover,
.aishoppingresultdata::-webkit-scrollbar-thumb:hover {
    background: #757d85;
}


.chatbot-user-chat-message-container {
    display: flex;
    margin: 15px 0;
    justify-content: flex-end;
}


.chatbot-user-chat-message {
    border-radius: 12px 12px 0px 12px;
    /* border: 1px solid #BEBFD3; */
    border: 1px solid #1B9298;
    /* background: #DEEBFF; */
    background: #F5FEFF;
    max-width: 50%;
    width: -moz-fit-content;
    width: fit-content;
    padding: 10px;
    font-size: 0.9rem;
    color: #585858;
    position: relative;
    text-align: left;
    overflow: hidden;
    word-wrap: break-word;
    /* word-break: break-all; */
    hyphens: auto;
    -webkit-hyphens: auto;
    /* -webkit-word-break: break-all; */
    -webkit-word-wrap: break-word;
    overflow-wrap: break-word;
    text-overflow: ellipsis;
    white-space: normal;


}

.chatbot-user-chat-message::first-letter,
.chatbot-chat-bot-message::first-letter {
    text-transform: uppercase;
}

.chatbot-user-chat-message-arrow,
.chatbot-chat-bot-message-arrow {
    display: none;
}

.chatbot-user-chat-message-arrow {
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-left: 8px solid #f1f1f1;
    position: absolute;
    right: -7px;
    top: 13px;
}

.chatbot-user-avatar-container {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-left: 12.5px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.chatbot-user-avatar-icon {
    fill: #fff;
    width: 100%;
}

.chatbot-chat-bot-message-container {
    max-width: 60%;
    width: -moz-fit-content;
    width: fit-content;
    display: flex;
    margin: 15px 0;
    justify-content: flex-start;
}

.chatbot-chat-bot-avatar-container {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    font-size: 1.2rem;
    margin-right: 12.5px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.chatbot-chat-bot-avatar-container img {
    width: 100%;
}

.chatbot-chat-bot-avatar~.chatbot-chat-bot-message {
    margin-left: 0;
}

.chatbot-chat-bot-message {
    width: 90%;
    color: #171A1F;
    border-radius: 12px 12px 12px 0px;
    border: 1px solid #BEBFD3;
    padding: 10px;
    font-size: 0.9rem;
    position: relative;
    text-align: left;
}

.chatbot-chat-bot-message-voice-icon {
    position: absolute;
    right: -9px;
    top: -9px;
    background: #DB487E;
    border-radius: 50%;
    cursor: pointer;
    height: 20px;
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.chatbot-chat-bot-message-voice-icon svg {
    color: white;
    display: inline-block;
    font-size: 16px;
    /* margin: 6px 4px; */
}

.AIoptions {
    padding-bottom: 15px;
}

.AIoptions .AIoptions-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.AIoptions .AIoptions-container .AIoptions-item {
    display: inline-flex;
    padding: 5px 6px 5px 8px;
    justify-content: center;
    align-items: center;
    border-radius: 9px;
    background: #E4E4E4;
    color: #565E6C;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    margin-right: 4px;
    margin-bottom: 8px;
    cursor: pointer;
    border: solid 1px #E4E4E4;
}

.AIoptions-item.item-active {
    color: #25C9D0 !important;
    border: solid 1px #25C9D0 !important;
    background: #fff !important;

}

.AIoptions .AIoptions-container .AIoptions-item:hover {
    color: #25C9D0;
    border: solid 1px #25C9D0;
    background: #fff;
}

.AIoptions .AIoptions-header {
    border-radius: 9px;
    background: #f0f1ff;
    display: inline-flex;
    padding: 6px 8px;
    color: #6d7fdc;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
}


.AIcustomCheckBox,
.AIcustomCheckBox:hover {
    height: 32px;
    color: rgba(0, 0, 0, 0.87);
    background: #fff;
    /* margin-right: 10px !important; */
    display: inline-block;
    border-radius: 32px !important;
    font-size: 12px;
    text-wrap: nowrap;
    align-items: center;
    padding-left: 12px !important;
    padding-right: 12px !important;
    border: 1px solid #25C9D0;
    font-family: 'Segoe UI', Roboto, sans-serif;
}


.AIcustomCheckBox span {
    padding: 0;
}

.AIcustomCheckBox svg {
    width: 16px !important;
}


/* sliders css  */

.AIchatBg {
    color: #171A1F;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 8px;
    width: 100%;
    margin-top: 50px;
    margin-bottom: 50px;

}


.AItripDetails {
    width: 95%;
    margin: 0 auto;
}

.AIresults-card {
    transition: all 0.3s ease;
    /* cursor: pointer; */
}

.AIresults-card:hover {
    transition: all 0.3s ease;
    transform: translateY(-3px);
    box-shadow: #ddd 0 20px 25px -5px, #ddd 0 10px 10px -5px;
}

.AIresults-card .AImeta {
    height: 150px;
}

.AIresults-card .destination-on-img {
    width: -moz-fit-content;
    width: fit-content;
    border-radius: 16px;
    color: #fff;
    background-color: #db487e;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: .5px;
    padding: 3px 10px;
    position: absolute;
    top: 15px;
    left: 15px;
    right: 15px;
    display: flex;
    align-items: start;
    gap: 2px;
    z-index: 1;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}


.AIresults-card .destination-on-img .FmdGoodIcon {
    width: 13px;
    height: 13px;
    font-size: 12px;
    color: #fff;
    position: relative;
    top: -2px;

}


.AItripDetails .AItripImg {
    overflow: hidden;
    height: 100%;
    position: relative;
}

.AItripDetails .AItripImg img {
    width: 100%;
    height: 100%;
    transition: transform 0.3s ease-in-out;
    object-fit: cover;
}

.AItripDetails .AItripImg img:hover {
    /* transform: scale(1.1); */
}

.AItripDetails .AItripImg img::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
}

.AItripDetails .AIdetails h2 {
    color: #000;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 10px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    height: 47px;
    /* margin-top: 8px; */
    margin: 0;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}

.AIdescription .grid-space {
    padding: .7rem 1rem 0rem !important;
}

.AIinfoText {
    font-size: 13px;
    color: #000;
}

.AIinfoText .AIlocation {
    margin-bottom: 12px;
    font-size: 14px;
    line-height: 16px;
    color: #000;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}

.AIinfoText .AIrating {
    margin-bottom: 12px;
    font-size: 14px;
    line-height: 16px;
    color: #000;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}

.AIinfoText .AIdate {
    margin-bottom: 12px;
    font-size: 12px;
    line-height: 16px;
    color: #000;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}


.AIrightDetails .AIlocation span,
.AIinfoText .AIrating span,
.AIinfoText .AIdate span {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}

.AIinfoText .icon {
    font-size: 18px;
    margin-right: 5px;
    color: #000;
}

.font-Roboto {
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}

.AIinfoText .AIrating .icon {
    font-size: 12px;
}

.AIinfoText .AIdealDates {
    text-decoration: none;
    line-height: 14px;
    padding: 12px;
    text-transform: math-auto;
    width: 100%;
    background: #ffffff;
    border: 2px solid #25c9d0;
    box-shadow: none;
    font-size: 15px;
    font-weight: 500;
    color: #000;
    border-radius: 4px;
    white-space: nowrap;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}

.AIinfoText .AIdealDates:hover {
    background-color: #25c9d0;
    color: #000
}

.AIrightDetails {
    font-size: 13px;
    /* text-align: center; */
    background-color: #f0f0f0;
    height: 100%;
    border-right: 1px solid #dbdbdb;
    color: #000;
    position: relative;
    margin: -16px;
    margin-top: 8px;
    padding: .5rem 1rem .7rem;
    margin-bottom: 0;
}

.AIrightDetails p {
    margin: 0;
}

.AIprice-h5 {
    /* font-size: 20px;
    line-height: 23px;
    color: #db487e;
    margin: 5px 0;
    display: flex;
    letter-spacing: -1px; */

    color: #db487e;
    font-size: 26px;
    margin-right: 4px;
    font-weight: 700 !important;
    position: relative;
    top: -8px;


}

.AIrightDetails .from-text {
    font-size: 12px;
    color: #454545;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;

}

.AIprice-h5 .dollar-icon {
    position: relative;
    top: 1px;
    font-size: 22px;
    left: -5px;
}

.AIprice-h5 .packagePrice {
    /* position: relative;
    left: -8px; */
    /* font-family: 'Roboto','Helvetica Neue', 'sans-serif' !important; */
}

.per-person-para-cls {
    color: #454545;
    font-weight: 500;
    font-size: 11px;
    color: #454545;
    line-height: 1.1;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
}

.AIrightDetails .price-disclmr-note {
    font-size: 11px;
    color: #454545;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;


}

.AIrightDetails .getDifferentDays {
    font-size: 11px;
    color: #454545;
    font-weight: 500;
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
    margin-bottom: 4px;

}

.AIrightDetails .book-the-deal {
    /* padding: .6rem 1rem 0px; */
    padding: 0.6rem 1rem 0 0.6rem;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 0 8px #c6c6c6;
    overflow: hidden;
    cursor: pointer;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    position: relative;

}

.AIrightDetails .book-the-deal .book-this-deal {
    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;
    margin-bottom: .2rem !important;
    font-size: 1rem;
    font-weight: 500;


}

.AIinfoText .AIdate .icon {
    color: #db487e;
    font-size: 16px;
}

.AIprice-margin-cls {
    margin-bottom: 4px !important;
    display: flex;
}

.AIrightDetails .AIbook-btn,
.AIrightDetails .AIbook-btn:hover,
.AIrightDetails .AIbook-btn:focus-visible {
    height: 2.7em;
    font-size: 12px;
    border: 1px solid #25C9D0;
    border-radius: 5px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    line-height: normal;
    margin-top: 10px;
    text-transform: math-auto;
    background: #25C9D0;
    color: #000;
    /* position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translate(-50%); */
    width: 55px;
    height: 83px;
    margin: -16px;
}

.AIrightDetails .AIbook-btn .icon {
    font-size: 18px;
    width: 20px;
    height: 20px;

}

.AIrightDetails .AIweather-places {
    font-size: 22px;
    display: flex;
    gap: 16px;
    justify-content: center;
    padding-top: 8px;
    margin-bottom: 8px;
    color: #000;
}

.AIrightDetails .AIweather-places .icons {
    cursor: pointer;
}

.AIweather-places .chatbot-chat-bot-message-voice-icon {
    width: 18px;
    height: 18px;
}

.AIweather-places .chatbot-chat-bot-message-voice-icon svg {
    font-size: 14px;
}

.AIrightDetails .AIweather-places .icons:nth-child(1) {
    color: #25C9D0;
}

.AIrightDetails .AIweather-places .icons:nth-child(2) {
    color: #DB487E;
}



.AItripDetails .slick-slide>div:first-child {
    width: 95%;
    background: #fff;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    margin-bottom: 25px;
}


.AItripDetails .slick-prev,
.AItripDetails .slick-next {
    color: #000 !important;
    width: 30px !important;
    height: auto !important;
}

.AItripDetails .slick-prev {
    left: -35px !important;
}

.AItripDetails .slick-next {
    right: -40px !important;
}

.AItripDetails .slick-disabled {
    opacity: 0.1;
    pointer-events: none;
}
.AiShoppingResult {
    font-family: 'Segoe UI', Roboto, sans-serif;
}
.AiShoppingResult h1 {
    font-size: 48px;
    font-weight: 400;
    line-height: 45.5px;
    font-family: "Agbalumo" !important;
    color: #cc4173;
    text-shadow: none;
    width: 750px;
    animation: typing 4s steps(50000), blink .5s step-end infinite alternate !important;
    white-space: nowrap;
    overflow: hidden;
    margin: 0 auto;
}

.ai-assistant-desc-cls {
    font-size: 20px;
    font-weight: 380;
    line-height: 30px;
    color: #333 !important;
    text-shadow: none;
    width: 600px;
    white-space: wrap;
    overflow: hidden;
    margin: 0 auto;
}

/* 
.ai-assistant-title-cls {
    font-size: 48px;
    font-weight: 400;
    line-height: 45.5px;
    font-family: "Agbalumo" !important;
    color: #cc4173 !important;
    text-shadow: none;
} */

.AiShoppingResult h1::after {
    display: block;
    contain: "...";
    width: 100px;
}


@keyframes typing {
    from {
        width: 0
    }
}

@keyframes blink {
    50% {
        border-color: transparent
    }
}

.AiShoppingResult h1 sup {
    font-size: 18px;
    font-weight: 400;
}

.AiShoppingResult h1 .badge {
    background: #DB487E;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    color: #fff;
    border-radius: 26px;
    padding: 5px 16px;
    position: relative;
    top: -5px;

}

.dialog-content-padding-cls {
    padding-bottom: 0px !important;
}

.chatbot-input-container-align-center {
    display: flex;
    align-items: center;
    justify-content: center;
    /* height: calc(100vh - 210px); */
    height: calc(100vh - 380px);
    animation: moveUp 1s forwards;
}

.chatbot-input-container-align-bottom {
    position: fixed;
    left: 0;
    width: 100%;
    bottom: 16px;
    animation: moveDown 1s forwards;
    /* background: #F3F3F3; */
    background-color: #fff;
    /* height: calc(100vh - 210px); */
}

@keyframes moveDown {
    0% {
        transform: translateY(-50vh);
    }

    100% {
        transform: translateY(0);
    }
}

@keyframes moveUp {
    0% {
        transform: translateY(40vh);
    }

    100% {
        transform: translateY(0vh);
    }
}


.chatbot-input-form {
    position: relative;
    /* width: 85%; */
    text-align: center;
    margin: 0 auto;
}


.chatbot-input {
    padding: 10px 20px;
    border-radius: 6px;
    border: 1px solid #25C9D0;
    background: #FFF;
    width: 100%;
    font-size: 16px;
    color: #05212A;
    font-weight: 400;
    animation: 2s ease-out;
    padding-right: 50px;
}

.chatbot-input:focus-visible {
    outline: 1px solid #25C9D0;
}

.chatbot-chat-btn-send {
    position: absolute;
    right: -6px;
    top: 7px;
    background: transparent !important;
    transition: transform 0.3s ease-in-out;
    width: 60px;
    border: none;
    border-bottom-right-radius: 5px;
    color: #999999;
}

.chatbot-chat-btn-send.mic-icon {
    right: 32px;
}

.chatbot-chat-btn-send.mic-icon svg {
    font-size: 18px;
}

.chatbot-kit-input-container .cta-btn {
    position: relative;
    display: inline-block;
    color: #666666;
    background: transparent;
    text-transform: none;
    padding: 5px 40px;
    white-space: nowrap;
    font-size: 0.775rem;
    border-radius: 5px;
    z-index: 1;
    overflow: hidden;
    font-weight: 500;
    font-family: 'Segoe UI', Roboto, sans-serif;
}

.chatbot-kit-input-container .cta-btn::before,
.chatbot-kit-input-container .cta-btn::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    z-index: -1;
}

.chatbot-kit-input-container .cta-btn::before {
    /* background: linear-gradient(to right, #25c9d0, #db487e); */
    background: linear-gradient(to right, #25C9D0, #fbee77, #DB487E);
    padding: 1px 1px;
    box-sizing: border-box;
}

.chatbot-kit-input-container .cta-btn::after {
    background: #fff;
    margin: 1px 1px;
    box-sizing: border-box;
}


.chatbot-kit-input-container .cta-btn:hover {
    /* background: #25C9D0;
    color: #000; */
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, .24);
}

.chatbot-input::placeholder {
    font-size: 14px;
}

.chatbot-input:focus+.chatbot-chat-btn-send .chatbot-chat-btn-send-icon {
    color: #25C9D0;
}

.chatbot-input-form .buttons-group {
    display: flex;
    justify-content: center;
    align-items: center;
    /* margin-top: 20px; */
    margin-top: 8px;
}

.narrow-suggestion-large-screens-text-cls {
    max-width: 150px;
}

.dropdown-box {
    position: absolute;
    background: #fff;
    width: 90%;
    height: calc(100% - 50px);
    left: 0;
    right: 0;
    top: 40px;
    z-index: 1;
    text-align: left;
    font-size: 14px;
    padding: 10px;
    margin: 0 auto;
    border: solid 1px rgb(0 0 0 / 20%);
    border-radius: 5px;
}

.cursor-pointer {
    cursor: pointer;
}

.aishoppingresultdata {
    margin-top: 80px;
    height: calc(100vh - 310px);
    overflow: scroll;
}

.aishoppingresultdata-height-cls {
    height: calc(100vh - 350px);
}

.aishoppingresultdata-height-fixing-based-on-disclaimer-cls {
    height: calc(100vh - 295px);
    /* height:100vh; */

}

.aishoppingresultdata-height-fixing-based-on-disclaimer-cls.enablenotice {
    height: calc(100vh - 380px);
}

.aishoppingresultempty {
    overflow: auto;
    margin-top: 120px;
}

.AItripDetails .slick-dots {
    top: -35px;
    left: auto;
    right: 0;
    width: auto;
    height: auto;

}

.AItripDetails .slick-dots li {
    width: auto;
    height: auto;
}

.AItripDetails .slick-dots li button:before {
    display: none;
}

.AItripDetails .slick-dots li button {
    background: rgb(0 0 0 / 30%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    transition: background-color 0.5s ease, width 0.5s ease, border-radius 0.5s ease;

}

.AItripDetails .slick-dots li.slick-active button {
    background-color: #25C9D0;
    width: 22px;
    border-radius: 8px;
    transition: background-color 0.5s ease, width 0.5s ease, border-radius 0.5s ease;
}

.MuiTooltip-tooltip {
    background: transparent;
}







@media (max-width: 992px) {
    .AiShoppingResult h1 {
        font-size: 40px;
        animation: none !important;
        width: 700px;
        word-wrap: normal;
        white-space: pre;
        line-height: 30px;
        word-wrap: break-word;
    }
}

/* For mobile devices: */
@media (max-width: 768px) {
    .voice-enable-button-m {
        right: -9px;
    }

    .AiShoppingResult h1 {
        font-size: 25px;
        animation: none !important;
        width: auto;
        word-wrap: normal;
        white-space: pre;
        line-height: 35px;
        word-wrap: break-word;
    }

    .AiShoppingResult h1 .badge {
        padding: 5px 8px;
        font-size: 9px;
        line-height: 4px;
        top: -3px;
    }

    .ai-assistant-desc-cls {
        font-size: 0.9rem;
        font-weight: 400;
        line-height: 20px;
        color: #333 !important;
        text-shadow: none;
        width: 400px;
        white-space: wrap;
        overflow: hidden;
        margin: 0 auto;
    }

    .chatbot-skeleton-input {
        height: 32px;
    }

    .chatbot-skeleton-btn {
        height: 32px;
    }

    .AiShoppingResult h1 sup {
        font-size: 12px;
        top: -1em;
    }

    .chatbot-input {
        display: block;
        width: 90%;
    }

    .chatbot-input::placeholder {
        font-size: 9px;
    }

    .chatbot-chat-btn-send.mic-icon {
        right: 70px;
    }

    .chatbot-chat-btn-send {
        right: 31px;
    }

    .aishoppingresultdata {
        /* height: calc(100dvh - 250px) !important; */
        /* height: calc(100dvh - 240px) !important; */

    }

    .aishoppingresultdata.enablenotice {
        /* height: calc(100dvh - 250px) !important; */
        height: calc(100dvh - 300px) !important;

    }

    .chatbot-chat-bot-message-container {
        max-width: 70%;
    }

    .chatbot-chat-bot-message-container {
        max-width: 90%;
    }

    .chatbot-user-chat-message,
    .chatbot-chat-bot-message-container {
        max-width: 80%;
    }

    .AItripDetails .slick-dots {
        display: none !important;
    }

    .AItripDetails .slick-slide>div:first-child {
        box-shadow: 8px 9px 5px -2px rgba(0, 0, 0, 0.15);
        margin-left: 8px;
    }

    .AItripDetails .slick-prev,
    .AItripDetails .slick-next {
        background: #fff;
        border-radius: 50%;
        padding: 8px;
        border: solid 1px rgb(0, 0, 0, 0.2);
    }

    .AItripDetails .slick-prev {
        left: -24px !important;
    }

    .AItripDetails .slick-next {
        right: -24px !important;
    }

    /* .AIrightDetails .stay-icons .sicon {
        display: none;
    } */

    .footer-mobile-cls {
        display: none !important;
    }

    .AIchatBg {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .AIresults-card .destination-on-img {
        font-size: 11px;
    }

    .AIrightDetails .AIbook-btn,
    .AIrightDetails .AIbook-btn:hover,
    .AIrightDetails .AIbook-btn:focus-visible {
        width: 50px;
    }
}

.narrow-suggestion-large-screens-text-cls {
    display: block !important;
}

.narrow-suggestion-mobile-text-cls {
    display: block !important;
    /* font-size: 12px; */
    /* font-weight: 400; */
}

@media (max-width: 992px) {

    .chatbot-kit-input-container .cta-btn {
        width: auto;
        /* border-radius: 10px; */
        /* border-radius: 5px; */
        min-width: auto !important;
        font-size: 12px;
        height: 35px;
        /* height: 45px; */
        border-radius: 6px;
        padding-left: 16px;
        padding-right: 16px;

    }

    .aishoppingresultdata {
        /* height: calc(100dvh - 260px); */
        height: calc(100dvh - 380px);
    }

    .aishoppingresultdata-height-fixing-based-on-disclaimer-cls {
        height: calc(100dvh - 320px);

    }

    .aishoppingresultdata-height-fixing-based-on-disclaimer-cls.enablenotice {
        height: calc(100dvh - 380px);

    }

    .chatbot-input-container-align-bottom {

        animation: none !important;
    }

    .chatbot-input-form .buttons-group {
        justify-content: left;
        /* justify-content: center; */
    }

    .chatbot-input-form .buttons-group {
        overflow-x: auto !important;
        margin-top: 8px;
        padding: 0 10px;
        padding-bottom: 8px;
    }

    .chatbot-input-form .buttons-group::-webkit-scrollbar,
    .AItripDetails .slick-list::-webkit-scrollbar {
        width: 3px !important;
        height: 3px !important;
    }

    .chatbot-input-form .buttons-group::-webkit-scrollbar-track,
    .AItripDetails .slick-list::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 18px #e0e1e2;
        border-radius: 2px;

    }

    .chatbot-input-form .buttons-group::-webkit-scrollbar-thumb,
    .AItripDetails .slick-list::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background-color: #999999 !important;
        width: 2px !important;
        height: 2px !important;
    }

    .chatbot-input-form .buttons-group::-webkit-scrollbar-thumb:hover,
    .AItripDetails .slick-list::-webkit-scrollbar-thumb:hover {
        background: #757d85;
    }

}

@media (max-width: 1200px) {

    .narrow-suggestion-large-screens-text-cls {
        display: none !important;
    }

    .narrow-suggestion-mobile-text-cls {
        display: block !important;
    }

    .chatbot-input-form .buttons-group {
        margin-top: 8px !important;
    }

    .chatbot-kit-input-container .cta-btn {
        width: auto;
        /* border-radius: 10px; */
        /* border-radius: 5px; */
        min-width: auto !important;
        font-size: 12px;
        /* height: 45px; */
        height: 35px;
        border-radius: 6px;
        padding-left: 16px;
        padding-right: 16px;

    }
}

.bouncing-loader-bot-img {
    position: relative;
    top: -15px;
}

.ai-assistant-titles-container-cls {
    /* width: 750px; */
    margin: 0 auto;
}

.footer-position-cls {
    width: 100%;
    position: absolute;
    bottom: 15px;
}

@media (max-width: 768px) {
    .chatbot-kit-input-container .cta-btn {
        font-size: 10px;
        height: 30px;
    }

}

@media (max-width: 575px) {
    .AiShoppingResult h1 {
        font-size: 21px;
    }

    .ai-assistant-desc-cls {
        font-size: 0.7rem;
        width: 320px;

    }


}

@media (max-width: 374px) {
    .AiShoppingResult h1 {
        white-space: wrap
    }

    .ai-assistant-desc-cls {
        font-size: 0.7rem;
        width: 280px;

    }
}

@media only screen and (max-width: 420px) {
    .aishoppingresultdata-height-fixing-based-on-disclaimer-cls {
        height: calc(100vh - 430px);
    }

    
}

@supports (-webkit-touch-callout: none) {
    @media only screen and (max-width: 420px) {
       
        .aishoppingresultdata-height-fixing-based-on-disclaimer-cls {
            height: calc(100vh - 430px);

        }

      
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/ai_style.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,SAAS;IACT,0BAA0B;IAC1B,gEAAgE;IAChE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;;;AAIA;;IAEI,6BAA6B;IAC7B,sEAAsE;;AAE1E;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,2DAA2D;IAE3D,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAGI,kBAAkB;IAClB,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;;IAEI,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,cAAc;IACd,yBAAyB;AAC7B;;;AAGA;IACI,iCAAiC;IACjC,+BAA+B;IAC/B,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,2BAA2B;IAC3B,aAAa;IACb,qBAAqB;IACrB,mCAAmC;IACnC,6BAA6B;IAC7B,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;;;AAGvB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,oCAAoC;IACpC,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,iCAAiC;IACjC,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,2BAA2B;;AAE/B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;;AAGA;;IAEI,YAAY;IACZ,0BAA0B;IAC1B,gBAAgB;IAChB,mCAAmC;IACnC,qBAAqB;IACrB,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,8BAA8B;IAC9B,yBAAyB;IACzB,2CAA2C;AAC/C;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA,iBAAiB;;AAEjB;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;;AAEvB;;;AAGA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,wDAAwD;AAC5D;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gEAAgE;AACpE;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,SAAS;;AAEb;;;AAGA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,SAAS;IACT,gEAAgE;AACpE;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gEAAgE;AACpE;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gEAAgE;AACpE;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gEAAgE;AACpE;;;AAGA;;;IAGI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,gEAAgE;AACpE;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,gEAAgE;AACpE;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,yBAAyB;IACzB,YAAY;IACZ,+BAA+B;IAC/B,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI;;;;;2BAKuB;;IAEvB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,SAAS;;;AAGb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gEAAgE;;AAEpE;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf,UAAU;AACd;;AAEA;IACI;iBACa;IACb,qEAAqE;AACzE;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gEAAgE;AACpE;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gEAAgE;;;AAGpE;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gEAAgE;IAChE,kBAAkB;;AAEtB;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;;AAEtB;;AAEA;IACI,gEAAgE;IAChE,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;;;AAGpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;;;IAGI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;;IAE5B,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX;;;iCAG6B;IAC7B,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;;AAIA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,6CAA6C;IAC7C,mBAAmB;AACvB;;;AAGA;;IAEI,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kCAAkC;IAClC,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,mFAAmF;IACnF,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;;;;;;;GAQG;;AAEH;IACI,cAAc;IACd,cAAc;IACd,YAAY;AAChB;;;AAGA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;;AAEb;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;IACjC,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,OAAO;IACP,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,yBAAyB;IACzB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;;AAGA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;;AAGA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,kCAAkC;IAClC,sCAAsC;IACtC,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,6DAA6D;IAC7D,gEAAgE;IAChE,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;;;AAGA;IACI;kBACc;IACd,yCAAyC;AAC7C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,yBAAyB;IACzB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,cAAc;IACd,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;;AAEtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,UAAU;IACV,QAAQ;IACR,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gFAAgF;;AAEpF;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,gFAAgF;AACpF;;AAEA;IACI,uBAAuB;AAC3B;;;;;;;;AAQA;IACI;QACI,eAAe;QACf,0BAA0B;QAC1B,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;QAChB,iBAAiB;QACjB,qBAAqB;IACzB;AACJ;;AAEA,wBAAwB;AACxB;IACI;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,0BAA0B;QAC1B,WAAW;QACX,iBAAiB;QACjB,gBAAgB;QAChB,iBAAiB;QACjB,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,iBAAiB;QACjB,sBAAsB;QACtB,iBAAiB;QACjB,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,6CAA6C;QAC7C,6CAA6C;;IAEjD;;IAEA;QACI,6CAA6C;QAC7C,uCAAuC;;IAE3C;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,gDAAgD;QAChD,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;QAChB,kBAAkB;QAClB,YAAY;QACZ,mCAAmC;IACvC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;OAEG;;IAEH;QACI,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;;;QAGI,WAAW;IACf;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;IAEI;QACI,WAAW;QACX,yBAAyB;QACzB,wBAAwB;QACxB,0BAA0B;QAC1B,eAAe;QACf,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;;IAEvB;;IAEA;QACI,kCAAkC;QAClC,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;;IAEhC;;IAEA;QACI,4BAA4B;;IAEhC;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,qBAAqB;QACrB,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;QAC3B,eAAe;QACf,eAAe;QACf,mBAAmB;IACvB;;IAEA;;QAEI,qBAAqB;QACrB,sBAAsB;IAC1B;;IAEA;;QAEI,0CAA0C;QAE1C,kBAAkB;;IAEtB;;IAEA;;QAGI,kBAAkB;QAClB,oCAAoC;QACpC,qBAAqB;QACrB,sBAAsB;IAC1B;;IAEA;;QAEI,mBAAmB;IACvB;;AAEJ;;AAEA;;IAEI;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,yBAAyB;QACzB,wBAAwB;QACxB,0BAA0B;QAC1B,eAAe;QACf,kBAAkB;QAClB,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;;IAEvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI;QACI,eAAe;QACf,YAAY;IAChB;;AAEJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,YAAY;;IAEhB;;;AAGJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,YAAY;;IAEhB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;;AAGJ;;AAEA;IACI;;QAEI;YACI,2BAA2B;;QAE/B;;;IAGJ;AACJ","sourcesContent":["body {\n    background-color: #fff !important;\n    margin: 0;\n    color: rgba(0, 0, 0, 0.87);\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n    font-weight: 400;\n    font-size: 1rem;\n    line-height: 1.5;\n    letter-spacing: 0.00938em;\n}\n\n\n\nbody,\n.aishoppingresultdata {\n    overflow-y: scroll !important;\n    /* font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important; */\n\n}\n\nbody::-webkit-scrollbar,\n.aishoppingresultdata::-webkit-scrollbar {\n    width: 3px !important;\n}\n\nbody::-webkit-scrollbar-track,\n.aishoppingresultdata::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 18px rgba(250, 250, 251, 0.3);\n    -webkit-border-radius: 5px;\n    border-radius: 2px;\n    margin-top: 16px;\n    margin-bottom: 16px;\n}\n\nbody::-webkit-scrollbar-thumb,\n.aishoppingresultdata::-webkit-scrollbar-thumb {\n    -webkit-border-radius: 5px;\n    border-radius: 5px;\n    background-color: #25C9D0 !important;\n    width: 6px !important;\n}\n\nbody::-webkit-scrollbar-thumb:hover,\n.aishoppingresultdata::-webkit-scrollbar-thumb:hover {\n    background: #757d85;\n}\n\n\n.chatbot-user-chat-message-container {\n    display: flex;\n    margin: 15px 0;\n    justify-content: flex-end;\n}\n\n\n.chatbot-user-chat-message {\n    border-radius: 12px 12px 0px 12px;\n    /* border: 1px solid #BEBFD3; */\n    border: 1px solid #1B9298;\n    /* background: #DEEBFF; */\n    background: #F5FEFF;\n    max-width: 50%;\n    width: -moz-fit-content;\n    width: fit-content;\n    padding: 10px;\n    font-size: 0.9rem;\n    color: #585858;\n    position: relative;\n    text-align: left;\n    overflow: hidden;\n    word-wrap: break-word;\n    /* word-break: break-all; */\n    hyphens: auto;\n    -webkit-hyphens: auto;\n    /* -webkit-word-break: break-all; */\n    -webkit-word-wrap: break-word;\n    overflow-wrap: break-word;\n    text-overflow: ellipsis;\n    white-space: normal;\n\n\n}\n\n.chatbot-user-chat-message::first-letter,\n.chatbot-chat-bot-message::first-letter {\n    text-transform: uppercase;\n}\n\n.chatbot-user-chat-message-arrow,\n.chatbot-chat-bot-message-arrow {\n    display: none;\n}\n\n.chatbot-user-chat-message-arrow {\n    width: 0;\n    height: 0;\n    border-top: 8px solid transparent;\n    border-bottom: 8px solid transparent;\n    border-left: 8px solid #f1f1f1;\n    position: absolute;\n    right: -7px;\n    top: 13px;\n}\n\n.chatbot-user-avatar-container {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    margin-left: 12.5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.chatbot-user-avatar-icon {\n    fill: #fff;\n    width: 100%;\n}\n\n.chatbot-chat-bot-message-container {\n    max-width: 60%;\n    width: -moz-fit-content;\n    width: fit-content;\n    display: flex;\n    margin: 15px 0;\n    justify-content: flex-start;\n}\n\n.chatbot-chat-bot-avatar-container {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    font-size: 1.2rem;\n    margin-right: 12.5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.chatbot-chat-bot-avatar-container img {\n    width: 100%;\n}\n\n.chatbot-chat-bot-avatar~.chatbot-chat-bot-message {\n    margin-left: 0;\n}\n\n.chatbot-chat-bot-message {\n    width: 90%;\n    color: #171A1F;\n    border-radius: 12px 12px 12px 0px;\n    border: 1px solid #BEBFD3;\n    padding: 10px;\n    font-size: 0.9rem;\n    position: relative;\n    text-align: left;\n}\n\n.chatbot-chat-bot-message-voice-icon {\n    position: absolute;\n    right: -9px;\n    top: -9px;\n    background: #DB487E;\n    border-radius: 50%;\n    cursor: pointer;\n    height: 20px;\n    width: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.chatbot-chat-bot-message-voice-icon svg {\n    color: white;\n    display: inline-block;\n    font-size: 16px;\n    /* margin: 6px 4px; */\n}\n\n.AIoptions {\n    padding-bottom: 15px;\n}\n\n.AIoptions .AIoptions-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n.AIoptions .AIoptions-container .AIoptions-item {\n    display: inline-flex;\n    padding: 5px 6px 5px 8px;\n    justify-content: center;\n    align-items: center;\n    border-radius: 9px;\n    background: #E4E4E4;\n    color: #565E6C;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 18px;\n    margin-right: 4px;\n    margin-bottom: 8px;\n    cursor: pointer;\n    border: solid 1px #E4E4E4;\n}\n\n.AIoptions-item.item-active {\n    color: #25C9D0 !important;\n    border: solid 1px #25C9D0 !important;\n    background: #fff !important;\n\n}\n\n.AIoptions .AIoptions-container .AIoptions-item:hover {\n    color: #25C9D0;\n    border: solid 1px #25C9D0;\n    background: #fff;\n}\n\n.AIoptions .AIoptions-header {\n    border-radius: 9px;\n    background: #f0f1ff;\n    display: inline-flex;\n    padding: 6px 8px;\n    color: #6d7fdc;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 20px;\n}\n\n\n.AIcustomCheckBox,\n.AIcustomCheckBox:hover {\n    height: 32px;\n    color: rgba(0, 0, 0, 0.87);\n    background: #fff;\n    /* margin-right: 10px !important; */\n    display: inline-block;\n    border-radius: 32px !important;\n    font-size: 12px;\n    text-wrap: nowrap;\n    align-items: center;\n    padding-left: 12px !important;\n    padding-right: 12px !important;\n    border: 1px solid #25C9D0;\n    font-family: 'Segoe UI', Roboto, sans-serif;\n}\n\n\n.AIcustomCheckBox span {\n    padding: 0;\n}\n\n.AIcustomCheckBox svg {\n    width: 16px !important;\n}\n\n\n/* sliders css  */\n\n.AIchatBg {\n    color: #171A1F;\n    padding-left: 12px;\n    padding-right: 12px;\n    padding-top: 8px;\n    width: 100%;\n    margin-top: 50px;\n    margin-bottom: 50px;\n\n}\n\n\n.AItripDetails {\n    width: 95%;\n    margin: 0 auto;\n}\n\n.AIresults-card {\n    transition: all 0.3s ease;\n    /* cursor: pointer; */\n}\n\n.AIresults-card:hover {\n    transition: all 0.3s ease;\n    transform: translateY(-3px);\n    box-shadow: #ddd 0 20px 25px -5px, #ddd 0 10px 10px -5px;\n}\n\n.AIresults-card .AImeta {\n    height: 150px;\n}\n\n.AIresults-card .destination-on-img {\n    width: fit-content;\n    border-radius: 16px;\n    color: #fff;\n    background-color: #db487e;\n    font-size: 14px;\n    font-weight: 600;\n    letter-spacing: .5px;\n    padding: 3px 10px;\n    position: absolute;\n    top: 15px;\n    left: 15px;\n    right: 15px;\n    display: flex;\n    align-items: start;\n    gap: 2px;\n    z-index: 1;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n\n.AIresults-card .destination-on-img .FmdGoodIcon {\n    width: 13px;\n    height: 13px;\n    font-size: 12px;\n    color: #fff;\n    position: relative;\n    top: -2px;\n\n}\n\n\n.AItripDetails .AItripImg {\n    overflow: hidden;\n    height: 100%;\n    position: relative;\n}\n\n.AItripDetails .AItripImg img {\n    width: 100%;\n    height: 100%;\n    transition: transform 0.3s ease-in-out;\n    object-fit: cover;\n}\n\n.AItripDetails .AItripImg img:hover {\n    /* transform: scale(1.1); */\n}\n\n.AItripDetails .AItripImg img::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.2);\n}\n\n.AItripDetails .AIdetails h2 {\n    color: #000;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 22px;\n    margin-bottom: 10px;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: pointer;\n    height: 47px;\n    /* margin-top: 8px; */\n    margin: 0;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n.AIdescription .grid-space {\n    padding: .7rem 1rem 0rem !important;\n}\n\n.AIinfoText {\n    font-size: 13px;\n    color: #000;\n}\n\n.AIinfoText .AIlocation {\n    margin-bottom: 12px;\n    font-size: 14px;\n    line-height: 16px;\n    color: #000;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n.AIinfoText .AIrating {\n    margin-bottom: 12px;\n    font-size: 14px;\n    line-height: 16px;\n    color: #000;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n.AIinfoText .AIdate {\n    margin-bottom: 12px;\n    font-size: 12px;\n    line-height: 16px;\n    color: #000;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n\n.AIrightDetails .AIlocation span,\n.AIinfoText .AIrating span,\n.AIinfoText .AIdate span {\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n.AIinfoText .icon {\n    font-size: 18px;\n    margin-right: 5px;\n    color: #000;\n}\n\n.font-Roboto {\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n.AIinfoText .AIrating .icon {\n    font-size: 12px;\n}\n\n.AIinfoText .AIdealDates {\n    text-decoration: none;\n    line-height: 14px;\n    padding: 12px;\n    text-transform: math-auto;\n    width: 100%;\n    background: #ffffff;\n    border: 2px solid #25c9d0;\n    box-shadow: none;\n    font-size: 15px;\n    font-weight: 500;\n    color: #000;\n    border-radius: 4px;\n    white-space: nowrap;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n.AIinfoText .AIdealDates:hover {\n    background-color: #25c9d0;\n    color: #000\n}\n\n.AIrightDetails {\n    font-size: 13px;\n    /* text-align: center; */\n    background-color: #f0f0f0;\n    height: 100%;\n    border-right: 1px solid #dbdbdb;\n    color: #000;\n    position: relative;\n    margin: -16px;\n    margin-top: 8px;\n    padding: .5rem 1rem .7rem;\n    margin-bottom: 0;\n}\n\n.AIrightDetails p {\n    margin: 0;\n}\n\n.AIprice-h5 {\n    /* font-size: 20px;\n    line-height: 23px;\n    color: #db487e;\n    margin: 5px 0;\n    display: flex;\n    letter-spacing: -1px; */\n\n    color: #db487e;\n    font-size: 26px;\n    margin-right: 4px;\n    font-weight: 700 !important;\n    position: relative;\n    top: -8px;\n\n\n}\n\n.AIrightDetails .from-text {\n    font-size: 12px;\n    color: #454545;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n\n}\n\n.AIprice-h5 .dollar-icon {\n    position: relative;\n    top: 1px;\n    font-size: 22px;\n    left: -5px;\n}\n\n.AIprice-h5 .packagePrice {\n    /* position: relative;\n    left: -8px; */\n    /* font-family: 'Roboto','Helvetica Neue', 'sans-serif' !important; */\n}\n\n.per-person-para-cls {\n    color: #454545;\n    font-weight: 500;\n    font-size: 11px;\n    color: #454545;\n    line-height: 1.1;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n}\n\n.AIrightDetails .price-disclmr-note {\n    font-size: 11px;\n    color: #454545;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n\n\n}\n\n.AIrightDetails .getDifferentDays {\n    font-size: 11px;\n    color: #454545;\n    font-weight: 500;\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n    margin-bottom: 4px;\n\n}\n\n.AIrightDetails .book-the-deal {\n    /* padding: .6rem 1rem 0px; */\n    padding: 0.6rem 1rem 0 0.6rem;\n    background: #fff;\n    border-radius: 8px;\n    box-shadow: 0 0 8px #c6c6c6;\n    overflow: hidden;\n    cursor: pointer;\n    margin-bottom: 16px;\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n\n}\n\n.AIrightDetails .book-the-deal .book-this-deal {\n    font-family: 'Roboto', 'Helvetica Neue', 'sans-serif' !important;\n    margin-bottom: .2rem !important;\n    font-size: 1rem;\n    font-weight: 500;\n\n\n}\n\n.AIinfoText .AIdate .icon {\n    color: #db487e;\n    font-size: 16px;\n}\n\n.AIprice-margin-cls {\n    margin-bottom: 4px !important;\n    display: flex;\n}\n\n.AIrightDetails .AIbook-btn,\n.AIrightDetails .AIbook-btn:hover,\n.AIrightDetails .AIbook-btn:focus-visible {\n    height: 2.7em;\n    font-size: 12px;\n    border: 1px solid #25C9D0;\n    border-radius: 5px;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n\n    line-height: normal;\n    margin-top: 10px;\n    text-transform: math-auto;\n    background: #25C9D0;\n    color: #000;\n    /* position: absolute;\n    bottom: 8px;\n    left: 50%;\n    transform: translate(-50%); */\n    width: 55px;\n    height: 83px;\n    margin: -16px;\n}\n\n.AIrightDetails .AIbook-btn .icon {\n    font-size: 18px;\n    width: 20px;\n    height: 20px;\n\n}\n\n.AIrightDetails .AIweather-places {\n    font-size: 22px;\n    display: flex;\n    gap: 16px;\n    justify-content: center;\n    padding-top: 8px;\n    margin-bottom: 8px;\n    color: #000;\n}\n\n.AIrightDetails .AIweather-places .icons {\n    cursor: pointer;\n}\n\n.AIweather-places .chatbot-chat-bot-message-voice-icon {\n    width: 18px;\n    height: 18px;\n}\n\n.AIweather-places .chatbot-chat-bot-message-voice-icon svg {\n    font-size: 14px;\n}\n\n.AIrightDetails .AIweather-places .icons:nth-child(1) {\n    color: #25C9D0;\n}\n\n.AIrightDetails .AIweather-places .icons:nth-child(2) {\n    color: #DB487E;\n}\n\n\n\n.AItripDetails .slick-slide>div:first-child {\n    width: 95%;\n    background: #fff;\n    overflow: hidden;\n    border-radius: 8px;\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n    margin-bottom: 25px;\n}\n\n\n.AItripDetails .slick-prev,\n.AItripDetails .slick-next {\n    color: #000 !important;\n    width: 30px !important;\n    height: auto !important;\n}\n\n.AItripDetails .slick-prev {\n    left: -35px !important;\n}\n\n.AItripDetails .slick-next {\n    right: -40px !important;\n}\n\n.AItripDetails .slick-disabled {\n    opacity: 0.1;\n    pointer-events: none;\n}\n.AiShoppingResult {\n    font-family: 'Segoe UI', Roboto, sans-serif;\n}\n.AiShoppingResult h1 {\n    font-size: 48px;\n    font-weight: 400;\n    line-height: 45.5px;\n    font-family: \"Agbalumo\" !important;\n    color: #cc4173;\n    text-shadow: none;\n    width: 750px;\n    animation: typing 4s steps(50000), blink .5s step-end infinite alternate !important;\n    white-space: nowrap;\n    overflow: hidden;\n    margin: 0 auto;\n}\n\n.ai-assistant-desc-cls {\n    font-size: 20px;\n    font-weight: 380;\n    line-height: 30px;\n    color: #333 !important;\n    text-shadow: none;\n    width: 600px;\n    white-space: wrap;\n    overflow: hidden;\n    margin: 0 auto;\n}\n\n/* \n.ai-assistant-title-cls {\n    font-size: 48px;\n    font-weight: 400;\n    line-height: 45.5px;\n    font-family: \"Agbalumo\" !important;\n    color: #cc4173 !important;\n    text-shadow: none;\n} */\n\n.AiShoppingResult h1::after {\n    display: block;\n    contain: \"...\";\n    width: 100px;\n}\n\n\n@keyframes typing {\n    from {\n        width: 0\n    }\n}\n\n@keyframes blink {\n    50% {\n        border-color: transparent\n    }\n}\n\n.AiShoppingResult h1 sup {\n    font-size: 18px;\n    font-weight: 400;\n}\n\n.AiShoppingResult h1 .badge {\n    background: #DB487E;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 18px;\n    color: #fff;\n    border-radius: 26px;\n    padding: 5px 16px;\n    position: relative;\n    top: -5px;\n\n}\n\n.dialog-content-padding-cls {\n    padding-bottom: 0px !important;\n}\n\n.chatbot-input-container-align-center {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    /* height: calc(100vh - 210px); */\n    height: calc(100vh - 380px);\n    animation: moveUp 1s forwards;\n}\n\n.chatbot-input-container-align-bottom {\n    position: fixed;\n    left: 0;\n    width: 100%;\n    bottom: 16px;\n    animation: moveDown 1s forwards;\n    /* background: #F3F3F3; */\n    background-color: #fff;\n    /* height: calc(100vh - 210px); */\n}\n\n@keyframes moveDown {\n    0% {\n        transform: translateY(-50vh);\n    }\n\n    100% {\n        transform: translateY(0);\n    }\n}\n\n@keyframes moveUp {\n    0% {\n        transform: translateY(40vh);\n    }\n\n    100% {\n        transform: translateY(0vh);\n    }\n}\n\n\n.chatbot-input-form {\n    position: relative;\n    /* width: 85%; */\n    text-align: center;\n    margin: 0 auto;\n}\n\n\n.chatbot-input {\n    padding: 10px 20px;\n    border-radius: 6px;\n    border: 1px solid #25C9D0;\n    background: #FFF;\n    width: 100%;\n    font-size: 16px;\n    color: #05212A;\n    font-weight: 400;\n    animation: 2s ease-out;\n    padding-right: 50px;\n}\n\n.chatbot-input:focus-visible {\n    outline: 1px solid #25C9D0;\n}\n\n.chatbot-chat-btn-send {\n    position: absolute;\n    right: -6px;\n    top: 7px;\n    background: transparent !important;\n    transition: transform 0.3s ease-in-out;\n    width: 60px;\n    border: none;\n    border-bottom-right-radius: 5px;\n    color: #999999;\n}\n\n.chatbot-chat-btn-send.mic-icon {\n    right: 32px;\n}\n\n.chatbot-chat-btn-send.mic-icon svg {\n    font-size: 18px;\n}\n\n.chatbot-kit-input-container .cta-btn {\n    position: relative;\n    display: inline-block;\n    color: #666666;\n    background: transparent;\n    text-transform: none;\n    padding: 5px 40px;\n    white-space: nowrap;\n    font-size: 0.775rem;\n    border-radius: 5px;\n    z-index: 1;\n    overflow: hidden;\n    font-weight: 500;\n    font-family: 'Segoe UI', Roboto, sans-serif;\n}\n\n.chatbot-kit-input-container .cta-btn::before,\n.chatbot-kit-input-container .cta-btn::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: inherit;\n    z-index: -1;\n}\n\n.chatbot-kit-input-container .cta-btn::before {\n    /* background: linear-gradient(to right, #25c9d0, #db487e); */\n    background: linear-gradient(to right, #25C9D0, #fbee77, #DB487E);\n    padding: 1px 1px;\n    box-sizing: border-box;\n}\n\n.chatbot-kit-input-container .cta-btn::after {\n    background: #fff;\n    margin: 1px 1px;\n    box-sizing: border-box;\n}\n\n\n.chatbot-kit-input-container .cta-btn:hover {\n    /* background: #25C9D0;\n    color: #000; */\n    box-shadow: 0 0 12px 0 rgba(0, 0, 0, .24);\n}\n\n.chatbot-input::placeholder {\n    font-size: 14px;\n}\n\n.chatbot-input:focus+.chatbot-chat-btn-send .chatbot-chat-btn-send-icon {\n    color: #25C9D0;\n}\n\n.chatbot-input-form .buttons-group {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /* margin-top: 20px; */\n    margin-top: 8px;\n}\n\n.narrow-suggestion-large-screens-text-cls {\n    max-width: 150px;\n}\n\n.dropdown-box {\n    position: absolute;\n    background: #fff;\n    width: 90%;\n    height: calc(100% - 50px);\n    left: 0;\n    right: 0;\n    top: 40px;\n    z-index: 1;\n    text-align: left;\n    font-size: 14px;\n    padding: 10px;\n    margin: 0 auto;\n    border: solid 1px rgb(0 0 0 / 20%);\n    border-radius: 5px;\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}\n\n.aishoppingresultdata {\n    margin-top: 80px;\n    height: calc(100vh - 310px);\n    overflow: scroll;\n}\n\n.aishoppingresultdata-height-cls {\n    height: calc(100vh - 350px);\n}\n\n.aishoppingresultdata-height-fixing-based-on-disclaimer-cls {\n    height: calc(100vh - 295px);\n    /* height:100vh; */\n\n}\n\n.aishoppingresultdata-height-fixing-based-on-disclaimer-cls.enablenotice {\n    height: calc(100vh - 380px);\n}\n\n.aishoppingresultempty {\n    overflow: auto;\n    margin-top: 120px;\n}\n\n.AItripDetails .slick-dots {\n    top: -35px;\n    left: auto;\n    right: 0;\n    width: auto;\n    height: auto;\n\n}\n\n.AItripDetails .slick-dots li {\n    width: auto;\n    height: auto;\n}\n\n.AItripDetails .slick-dots li button:before {\n    display: none;\n}\n\n.AItripDetails .slick-dots li button {\n    background: rgb(0 0 0 / 30%);\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    transition: background-color 0.5s ease, width 0.5s ease, border-radius 0.5s ease;\n\n}\n\n.AItripDetails .slick-dots li.slick-active button {\n    background-color: #25C9D0;\n    width: 22px;\n    border-radius: 8px;\n    transition: background-color 0.5s ease, width 0.5s ease, border-radius 0.5s ease;\n}\n\n.MuiTooltip-tooltip {\n    background: transparent;\n}\n\n\n\n\n\n\n\n@media (max-width: 992px) {\n    .AiShoppingResult h1 {\n        font-size: 40px;\n        animation: none !important;\n        width: 700px;\n        word-wrap: normal;\n        white-space: pre;\n        line-height: 30px;\n        word-wrap: break-word;\n    }\n}\n\n/* For mobile devices: */\n@media (max-width: 768px) {\n    .voice-enable-button-m {\n        right: -9px;\n    }\n\n    .AiShoppingResult h1 {\n        font-size: 25px;\n        animation: none !important;\n        width: auto;\n        word-wrap: normal;\n        white-space: pre;\n        line-height: 35px;\n        word-wrap: break-word;\n    }\n\n    .AiShoppingResult h1 .badge {\n        padding: 5px 8px;\n        font-size: 9px;\n        line-height: 4px;\n        top: -3px;\n    }\n\n    .ai-assistant-desc-cls {\n        font-size: 0.9rem;\n        font-weight: 400;\n        line-height: 20px;\n        color: #333 !important;\n        text-shadow: none;\n        width: 400px;\n        white-space: wrap;\n        overflow: hidden;\n        margin: 0 auto;\n    }\n\n    .chatbot-skeleton-input {\n        height: 32px;\n    }\n\n    .chatbot-skeleton-btn {\n        height: 32px;\n    }\n\n    .AiShoppingResult h1 sup {\n        font-size: 12px;\n        top: -1em;\n    }\n\n    .chatbot-input {\n        display: block;\n        width: 90%;\n    }\n\n    .chatbot-input::placeholder {\n        font-size: 9px;\n    }\n\n    .chatbot-chat-btn-send.mic-icon {\n        right: 70px;\n    }\n\n    .chatbot-chat-btn-send {\n        right: 31px;\n    }\n\n    .aishoppingresultdata {\n        /* height: calc(100dvh - 250px) !important; */\n        /* height: calc(100dvh - 240px) !important; */\n\n    }\n\n    .aishoppingresultdata.enablenotice {\n        /* height: calc(100dvh - 250px) !important; */\n        height: calc(100dvh - 300px) !important;\n\n    }\n\n    .chatbot-chat-bot-message-container {\n        max-width: 70%;\n    }\n\n    .chatbot-chat-bot-message-container {\n        max-width: 90%;\n    }\n\n    .chatbot-user-chat-message,\n    .chatbot-chat-bot-message-container {\n        max-width: 80%;\n    }\n\n    .AItripDetails .slick-dots {\n        display: none !important;\n    }\n\n    .AItripDetails .slick-slide>div:first-child {\n        box-shadow: 8px 9px 5px -2px rgba(0, 0, 0, 0.15);\n        margin-left: 8px;\n    }\n\n    .AItripDetails .slick-prev,\n    .AItripDetails .slick-next {\n        background: #fff;\n        border-radius: 50%;\n        padding: 8px;\n        border: solid 1px rgb(0, 0, 0, 0.2);\n    }\n\n    .AItripDetails .slick-prev {\n        left: -24px !important;\n    }\n\n    .AItripDetails .slick-next {\n        right: -24px !important;\n    }\n\n    /* .AIrightDetails .stay-icons .sicon {\n        display: none;\n    } */\n\n    .footer-mobile-cls {\n        display: none !important;\n    }\n\n    .AIchatBg {\n        margin-top: 10px;\n        margin-bottom: 10px;\n    }\n\n    .AIresults-card .destination-on-img {\n        font-size: 11px;\n    }\n\n    .AIrightDetails .AIbook-btn,\n    .AIrightDetails .AIbook-btn:hover,\n    .AIrightDetails .AIbook-btn:focus-visible {\n        width: 50px;\n    }\n}\n\n.narrow-suggestion-large-screens-text-cls {\n    display: block !important;\n}\n\n.narrow-suggestion-mobile-text-cls {\n    display: block !important;\n    /* font-size: 12px; */\n    /* font-weight: 400; */\n}\n\n@media (max-width: 992px) {\n\n    .chatbot-kit-input-container .cta-btn {\n        width: auto;\n        /* border-radius: 10px; */\n        /* border-radius: 5px; */\n        min-width: auto !important;\n        font-size: 12px;\n        height: 35px;\n        /* height: 45px; */\n        border-radius: 6px;\n        padding-left: 16px;\n        padding-right: 16px;\n\n    }\n\n    .aishoppingresultdata {\n        /* height: calc(100dvh - 260px); */\n        height: calc(100dvh - 380px);\n    }\n\n    .aishoppingresultdata-height-fixing-based-on-disclaimer-cls {\n        height: calc(100dvh - 320px);\n\n    }\n\n    .aishoppingresultdata-height-fixing-based-on-disclaimer-cls.enablenotice {\n        height: calc(100dvh - 380px);\n\n    }\n\n    .chatbot-input-container-align-bottom {\n\n        animation: none !important;\n    }\n\n    .chatbot-input-form .buttons-group {\n        justify-content: left;\n        /* justify-content: center; */\n    }\n\n    .chatbot-input-form .buttons-group {\n        overflow-x: auto !important;\n        margin-top: 8px;\n        padding: 0 10px;\n        padding-bottom: 8px;\n    }\n\n    .chatbot-input-form .buttons-group::-webkit-scrollbar,\n    .AItripDetails .slick-list::-webkit-scrollbar {\n        width: 3px !important;\n        height: 3px !important;\n    }\n\n    .chatbot-input-form .buttons-group::-webkit-scrollbar-track,\n    .AItripDetails .slick-list::-webkit-scrollbar-track {\n        -webkit-box-shadow: inset 0 0 18px #e0e1e2;\n        -webkit-border-radius: 5px;\n        border-radius: 2px;\n\n    }\n\n    .chatbot-input-form .buttons-group::-webkit-scrollbar-thumb,\n    .AItripDetails .slick-list::-webkit-scrollbar-thumb {\n        -webkit-border-radius: 5px;\n        border-radius: 5px;\n        background-color: #999999 !important;\n        width: 2px !important;\n        height: 2px !important;\n    }\n\n    .chatbot-input-form .buttons-group::-webkit-scrollbar-thumb:hover,\n    .AItripDetails .slick-list::-webkit-scrollbar-thumb:hover {\n        background: #757d85;\n    }\n\n}\n\n@media (max-width: 1200px) {\n\n    .narrow-suggestion-large-screens-text-cls {\n        display: none !important;\n    }\n\n    .narrow-suggestion-mobile-text-cls {\n        display: block !important;\n    }\n\n    .chatbot-input-form .buttons-group {\n        margin-top: 8px !important;\n    }\n\n    .chatbot-kit-input-container .cta-btn {\n        width: auto;\n        /* border-radius: 10px; */\n        /* border-radius: 5px; */\n        min-width: auto !important;\n        font-size: 12px;\n        /* height: 45px; */\n        height: 35px;\n        border-radius: 6px;\n        padding-left: 16px;\n        padding-right: 16px;\n\n    }\n}\n\n.bouncing-loader-bot-img {\n    position: relative;\n    top: -15px;\n}\n\n.ai-assistant-titles-container-cls {\n    /* width: 750px; */\n    margin: 0 auto;\n}\n\n.footer-position-cls {\n    width: 100%;\n    position: absolute;\n    bottom: 15px;\n}\n\n@media (max-width: 768px) {\n    .chatbot-kit-input-container .cta-btn {\n        font-size: 10px;\n        height: 30px;\n    }\n\n}\n\n@media (max-width: 575px) {\n    .AiShoppingResult h1 {\n        font-size: 21px;\n    }\n\n    .ai-assistant-desc-cls {\n        font-size: 0.7rem;\n        width: 320px;\n\n    }\n\n\n}\n\n@media (max-width: 374px) {\n    .AiShoppingResult h1 {\n        white-space: wrap\n    }\n\n    .ai-assistant-desc-cls {\n        font-size: 0.7rem;\n        width: 280px;\n\n    }\n}\n\n@media only screen and (max-width: 420px) {\n    .aishoppingresultdata-height-fixing-based-on-disclaimer-cls {\n        height: calc(100vh - 430px);\n    }\n\n    \n}\n\n@supports (-webkit-touch-callout: none) {\n    @media only screen and (max-width: 420px) {\n       \n        .aishoppingresultdata-height-fixing-based-on-disclaimer-cls {\n            height: calc(100vh - 430px);\n\n        }\n\n      \n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
